import React from "react";
import Modal from "react-modal";
import "./PopUpAddress.scss";
import { ReactComponent as Arrow } from "./../../../assets/svg/arrow.svg";
import { Link } from "react-router-dom";
import { ReactComponent as Close } from "../../../assets/svg/close.svg";
import { useTranslation } from "react-i18next";
import { useAuthValidation } from "../../../hooks/useAuthValidation"; // Hook para acessar o contexto de autenticação

Modal.setAppElement("#root");

function PopUpAddress({ isOpen, closeModal }) {
  const { t } = useTranslation();
  const { user, loading } = useAuthValidation(); // Obtém dados do usuário e estado de carregamento do contexto

  // Exibe carregamento enquanto o contexto está carregando
  if (loading) {
    return <div className="loading">{t("loading")}</div>;
  }

  // Se o usuário não estiver autenticado, não renderiza o modal
  if (!user) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel={t("address-pop-up-title")}
      className="open-address"
    >
      <div className="row">
        <h2>{t("notification-title-2")}</h2>
        <button onClick={closeModal} className="row link">
          <Close />
          <span>{t("address-pop-up-close")}</span>
        </button>
      </div>
      <h3>{t("address-pop-up-title")}</h3>
      <p>{t("address-pop-up-text")}</p>
      <Link to="/editar-endereco" className="button row">
        <span>{t("address-pop-up-button")}</span>
        <Arrow />
      </Link>
    </Modal>
  );
}

export default PopUpAddress;
